import { ChakraProvider, Box, Grid, extendTheme, CSSReset, Text, Avatar, AvatarBadge, useColorMode } from "@chakra-ui/react";
import { Global, css } from "@emotion/react";
import theme from "./theme/theme";
import Hero from "./Components/Hero";
import Header from "./Components/Header";
import { Sidebar } from "./theme/components/Sidebar";
import { useState } from "react";
import Resume from "./Components/Resume";
import backgroundImage from "./images/backdrop.jpg";
import Portfolio from "./Components/Portfolio";
import Blog from "./Components/Blog";
import Contact from "./Components/Contact";

function Layout() {
  const [currentView, setCurrentView] = useState("About");
  const { colorMode } = useColorMode();

  const renderContent = () => {
    switch (currentView) {
      case "About":
        return <Hero />;
      case "Resume":
        return <Resume />;
      case "Portfolio":
        return <Portfolio />;
      case "Blog":
        return <Blog />;
      case "Contact":
        return <Contact />;
      default:
        return <Hero />;
    }
  };

  return (
    <>
    <Box
      height="100vh" // Full view height
      width="full" // Full width of the viewport
      bgImage={`url(${backgroundImage})`} // Background image
      bgPosition="center" // Center the background image
      bgRepeat="no-repeat" // Do not repeat the background image
      bgSize="cover" // Cover the entire box area
      position="relative" // Relative position for overlay
      borderRadius="xs"
      //onTouchStart={handleTouchStart} // Detect touch events to disable cursor
      //onClick={isTouch ? createSpark : null}
      overflow="auto"
      //ref={heroRef}
    >
      {/* Black overlay with opacity */}
      <Box
        position="fixed" // Absolute position to overlay on top of the background
        top="0"
        right="0"
        bottom="0"
        left="0"
        bg={colorMode === "dark" ? "blackAlpha.800" : "whiteAlpha.800"}
        zIndex="1" // Ensure it's above the background image
        borderRadius="xs"
      />
      <CSSReset />
      <Global
        styles={css`
          body {
            background: ${colorMode === "dark"
              ? "linear-gradient(270deg, #00072d, #212529)"
              : "linear-gradient(270deg, #f0e7db, #f9f7f7)"};
            background-size: 400% 400%;
            animation: gradientAnimation 15s ease infinite;
          }
          @keyframes gradientAnimation {
            0% {
              background-position: 0% 50%;
            }
            50% {
              background-position: 100% 50%;
            }
            100% {
              background-position: 0% 50%;
            }
          }
        `}
      />
      <Grid
        templateColumns={{ base: "1fr", md: "300px 1fr" }}
        gap={4}
        p={4}
        height={{ base: "auto", md: "100vh" }}
        //overflowY="auto"
      >
        <Box
          //bg="#000814"
          //color="white"
          p={4}
          borderRadius="md"
          bg={colorMode === "dark" ? "gray.800" : "white"}
          color={colorMode === "dark" ? "white" : "black"}
          height={{ base: "auto", md: "calc(100vh - 32px)" }} // Adjust height for mobile
          position={{ base: "relative", md: "sticky" }}
          top={4}
          boxShadow="lg" // Adding shadow
          zIndex={"2"}
        >
          <Sidebar />
        </Box>
        <Box
          //bg="brand.200"
          color="white"
          //p={4}
          borderRadius="md"
          boxShadow="lg" // Adding shadow
          overflowY="auto" // Ensure scrolling
          position="relative"
          zIndex={"2"}

        >
          <Header setCurrentView={setCurrentView} currentView={currentView} />
          {renderContent()}
        </Box>
      </Grid>
      </Box>
    </>
  );
}

export default Layout;
